import React from 'react';

interface SpinnerProps {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string; // For custom colors
    light?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({
    size = 'md',
    className = '',
    light = false
}) => {
    const sizeClasses = {
        sm: 'w-4 h-4 border-2',
        md: 'w-6 h-6 border-[3px]',
        lg: 'w-10 h-10 border-4',
        xl: 'w-16 h-16 border-[5px]'
    };

    const colorClass = light 
        ? 'border-white/30 border-t-white' 
        : 'border-gray-200 dark:border-gray-700 border-t-primary dark:border-t-primary';

    return (
        <div 
            className={`animate-spin rounded-full ${sizeClasses[size]}
                ${colorClass}
                ${className}
            `}
            role="status"
            aria-label="Loading"
        />
    );
};













